module.exports = __webpack_public_path__ + "img/image-doc.6399d014.png";